import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7cb88f3f")

_pushScopeId("data-v-7cb88f3f")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: "title" }, "Users authorization", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Admin role has acces to "),
  /*#__PURE__*/_createVNode("b", null, "server settings"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" Moreover admins can review and decline users absences ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "table is-narrow is-fullwidth"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("th", null, "User"),
  /*#__PURE__*/_createVNode("th", { width: "100" }, "Role"),
  /*#__PURE__*/_createVNode("th", null, "Action")
], -1)
const _hoisted_8 = {
  key: 0,
  class: "section"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_user_auth_row = _resolveComponent("user-auth-row")
  const _component_add_user = _resolveComponent("add-user")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      (!_ctx.isLoading)
        ? (_openBlock(), _createBlock("table", _hoisted_6, [
            _hoisted_7,
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                return (_openBlock(), _createBlock(_component_user_auth_row, {
                  key: user.id,
                  user: user,
                  onGrantAdmin: () => (user.role = 'admin'),
                  onRevokeAdmin: () => (user.role = 'user'),
                  onRefresh: _ctx.refresh
                }, null, 8, ["user", "onGrantAdmin", "onRevokeAdmin", "onRefresh"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isManagementUser)
      ? (_openBlock(), _createBlock("div", _hoisted_8, [
          _createVNode(_component_add_user)
        ]))
      : _createCommentVNode("", true)
  ]))
})